export const FinicityLoading = () => {
  return (
    <div className="flex justify-center flex-1 finicity-loading">
      <p className="rounded-full shadow-md py-1 px-3 font-b6 text-t2-regular" style={{fontSize: "13px"}}>
        Loading...
      </p>
    </div>
  );
}